import React, { useState } from 'react'
import './header-searcher.scss'
import SearchInputFilter from '../../atoms/search-input-filter/search-input-filter';

const HeaderSearcher = props =>{
    const [inputValue, setValue] = useState('');

    /** logic filter searching */
    const search = (value) => {
        if(localStorage.getItem('HISTORY') !== null){
            var listHistory = JSON.parse(localStorage.getItem('HISTORY'));
            listHistory.push({metaTitulo: value})
            localStorage.setItem("HISTORY",JSON.stringify(listHistory));
        }else{
            localStorage.setItem("HISTORY",JSON.stringify([{metaTitulo: value}]));
        }
        props.setSerched(value)
        props.setnumArticles(6)
        if(value !== ""){           
            if(props.contennInfo){
                const filterContentInfo = props.contennInfo.filter((info) =>
                (info.metaTitulo && (info.metaTitulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim()) > -1 ))|| 
                (info.metaDescripcion && (info.metaDescripcion.metaDescripcion.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim()) > -1))
            )
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                'event': 'gaEvent',
                'eventTrigger': 'searchResults',
                'eventCategory': 'Search results',
                'eventAction': filterContentInfo.length, //this have to be dynamically pushed.
                'eventLabel': value, //this have to be dynamically pushed.
                'eventValue': undefined
              })  
                props.setItemsFilter(props.contennInfo.filter((info) =>
                    (info.metaTitulo && (info.metaTitulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim()) > -1 ))|| 
                    (info.metaDescripcion && (info.metaDescripcion.metaDescripcion.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim()) > -1))
                ))
            }
        }else{
            props.setItemsFilter([])
        }
    }


    return (
        <div className={inputValue === "" ? "f-HeaderSearcher": "f-HeaderSearcher f-HeaderSearcher-active"}>
                <h1>¿Qué estás <span>buscando?</span></h1>
               <SearchInputFilter
                                setValue={setValue}
                                inputValue={inputValue}
                                contennInfo={props.contennInfo}
                                search={search}
                                mobile={props.mobile}

                            />
        </div>
    )
}
export default HeaderSearcher;
